import { render, staticRenderFns } from "./comp_CheckoutStep-contact--active.vue?vue&type=template&id=235f0bb3&scoped=true&"
import script from "./comp_CheckoutStep-contact--active.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-contact--active.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-contact--active.vue?vue&type=style&index=0&id=235f0bb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f0bb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRadio,VRadioGroup,VRow,VSpacer})
